import React, { FC } from 'react';
import { RenewalLine } from '../../utils/renewalTableTileTypes';
import { RenewalLineType } from '../RenewalLineType';
import { RenewalLineItems } from '../RenewalLineItems';
import { SubscriptionRenewalLineItemUpdate } from '../../../../store/api';
import { RenewalLineTotal } from '../RenewalLineTotal';

export const RenewalLineCell: FC<RenewalLine> = props => {
    const { selectedType, types, total, items, onRenewalLineUpdate } = props;

    const handleSubmitTypeChange = type => {
        const lineItems = items.map(item => ({
            usageCondition: {
                usageLimit: item.price.usageLimit,
                lendingModel: item.price.lendingModel,
                termLimit: item.price.termLimit
            },
            amount: item.amount
        }));

        onRenewalLineUpdate({ type, lineItems: type === 'CUSTOM' ? lineItems : null });
    };

    const updateRenewalLineItem = (lineItems: SubscriptionRenewalLineItemUpdate[]) => {
        onRenewalLineUpdate({
            type: 'CUSTOM',
            lineItems
        });
    };

    return (
        <>
            <RenewalLineType selectedType={selectedType} types={types} handleTypeChange={handleSubmitTypeChange} />
            <RenewalLineItems items={items} onAmountChange={item => updateRenewalLineItem(item)} />
            <RenewalLineTotal total={total} />
        </>
    );
};
